import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Review-only: fake API + fake sign-in. REACT_APP_PREVIEW is never set for production builds, so this branch (and the
// sample data it imports) is removed from the bundle.
if (process.env.REACT_APP_PREVIEW === '1') {
  require('./preview/enablePreview');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
